export default (t) => [
  {
    text: t('Recipe Name'),
    value: 'name',
    sortable: false,
    width: 150,
    togglable: true
  },
  {
    text: t('Batch No.'),
    value: 'document_no',
    sortable: false,
    width: 300,
    togglable: true
  },
  {
    text: t('Branch'),
    value: 'branch',
    sortable: false,
    width: 75,
    togglable: true
  },
  {
    text: t('Status'),
    value: 'status',
    sortable: false,
    width: 50,
    togglable: true
  },
  {
    text: t('Size'),
    value: 'batch_multiplier',
    sortable: false,
    width: 100,
    togglable: true
  },
  {
    text: t('Created At'),
    value: 'created_at',
    sortable: true,
    width: 100,
    togglable: true
  },
  {
    text: t('Create By'),
    value: 'created_by',
    sortable: false,
    width: 100,
    togglable: true
  },
  {
    text: t('Action'),
    value: 'action',
    sortable: false,
    width: 20
  },
];
